"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScrollToTarget = /** @class */ (function () {
    function ScrollToTarget() {
        var _this = this;
        var links = document.querySelectorAll('a');
        links === null || links === void 0 ? void 0 : links.forEach(function (link) {
            var _a, _b;
            // Filter all anchor tags with an element as target
            if (((_a = link.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.includes('#')) && !((_b = link.getAttribute('target')) === null || _b === void 0 ? void 0 : _b.includes("_blank"))) {
                link.addEventListener('click', function () {
                    var target = link.getAttribute('href');
                    _this.scrollToTarget(event, target);
                });
            }
        });
    }
    // Function to scroll to the given element in the anchor
    ScrollToTarget.prototype.scrollToTarget = function (e, target) {
        e.preventDefault();
        var elID = target.replace('#', '');
        var t = document.getElementById(elID);
        var y = t.getBoundingClientRect().top + window.pageYOffset - 30;
        window.scrollTo({ top: y, behavior: 'smooth' });
    };
    return ScrollToTarget;
}());
exports.default = ScrollToTarget;
